/* Block - Carousel.
 *
 * Imports the block css.
 * Contains block-specific functionality.
 *
 * @file single
 *
 */
/* eslint-disable-next-line */

/* eslint-disable-next-line */
import styles from './block-carousel.scss';
import rsCarousel from '../../js/component/_carousel';

const carousels = Array.from(document.querySelectorAll('body:not(.wp-admin) .rs-carousel'));

rsCarousel.init(carousels);
